export default __webpack_public_path__ + "static/media/operation.634f0b12.svg";